import '../styles/LandingHero.css';
import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';

const HERO_PHOTO =
  'https://images.unsplash.com/photo-1547592180-85f173990554?auto=format&fit=crop&w=1600&q=80';

const HERO_PHOTO_ALT =
  'A family gathered around a warm kitchen table in natural daylight';

/* Mid-century geometric pattern block for the photo corner */
function PatternBlock() {
  return (
    <svg
      className="lh-hero__pattern"
      viewBox="0 0 84 84"
      role="presentation"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="84" height="84" rx="14" fill="#FBF6EC" />
      <path d="M0 84 A84 84 0 0 1 84 0 L84 84 Z" fill="#1F4E4A" />
      <circle cx="26" cy="26" r="14" fill="#D9502E" />
      <circle cx="26" cy="26" r="6" fill="#FBF6EC" />
      <rect x="48" y="12" width="24" height="4" rx="2" fill="#23201C" />
      <rect x="48" y="22" width="16" height="4" rx="2" fill="#23201C" />
    </svg>
  );
}

export default function LandingHero() {
  return (
    <section className="lh-hero" aria-labelledby="lh-hero-title">
      <div className="lh-hero__rail" data-content-rail="primary">
        <figure className="lh-hero__photo">
          <img
            className="lh-hero__img"
            src={HERO_PHOTO}
            alt={HERO_PHOTO_ALT}
            loading="eager"
            decoding="async"
          />
          <PatternBlock />
          <figcaption className="lh-hero__photo-caption">Montreaux &middot; everyday lending</figcaption>
        </figure>

        <div className="lh-hero__panel">
          <p className="lh-hero__eyebrow">Montreaux</p>

          <h1 className="lh-hero__title" id="lh-hero-title">
            <span className="lh-hero__title-line">Loans for</span>
            <span className="lh-hero__title-line">everyday</span>
            <span className="lh-hero__title-line">
              <span className="lh-hero__title-accent">people</span>
            </span>
          </h1>

          <p className="lh-hero__body">
            A simple loan service for everyday applicants. Read what Montreaux offers, then send a
            request in one visit &mdash; no account, no sign-in.
          </p>

          <div className="lh-hero__actions">
            <a className="lh-hero__apply" href="/apply">
              <span>Apply now</span>
              <span className="lh-hero__apply-icon" aria-hidden="true">
                <ArrowUpRight size={16} strokeWidth={2.2} />
              </span>
            </a>
            <a className="lh-hero__loans" href="/loans">
              <span>See the loans</span>
              <ArrowRight size={18} strokeWidth={2} aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>

      <svg
        className="lh-hero__arc"
        viewBox="0 0 1200 64"
        preserveAspectRatio="none"
        role="presentation"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M0 58 C 220 58, 360 6, 600 6 S 980 58, 1200 58" />
        <circle className="lh-hero__arc-dot" cx="600" cy="6" r="5" />
      </svg>
    </section>
  );
}